import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "./EAArticle.scss";

interface IProps {
  content: string; // HTML content to display
  maxHeight?: string; // Max height of container (default: 320px)
  showScrollHint?: boolean; // Whether to show scroll hint (default: true)
  className?: string; // Additional CSS class
}

const EAArticle: React.FC<IProps> = ({ content, maxHeight = "320px", showScrollHint = true, className = "" }) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const [hasTopShadow, setHasTopShadow] = useState(false);
  const [hasBottomShadow, setHasBottomShadow] = useState(false);
  const [showHint, setShowHint] = useState(false);

  // Scroll shadow management function
  const updateShadows = () => {
    const el = containerRef.current;
    if (!el) return;
    const { scrollTop, scrollHeight, clientHeight } = el;
    setHasTopShadow(scrollTop > 0);
    setHasBottomShadow(scrollTop + clientHeight < scrollHeight - 1);
  };

  // Initialize scroll shadows and hint
  useEffect(() => {
    updateShadows();
    const el = containerRef.current;
    if (el && showScrollHint) {
      const hasOverflow = el.scrollHeight > el.clientHeight + 1;
      setShowHint(hasOverflow);
    }
  }, [content, showScrollHint]);

  return (
    <div
      ref={containerRef}
      className={
        `ea-article ${className}` +
        (hasTopShadow ? " has-top-shadow" : "") +
        (hasBottomShadow ? " has-bottom-shadow" : "")
      }
      style={{ maxHeight }}
      onScroll={(e) => {
        updateShadows();
        const el = e.currentTarget as HTMLDivElement;
        if (el.scrollTop > 0 && showHint) {
          setShowHint(false);
        }
      }}
    >
      <article dangerouslySetInnerHTML={{ __html: content }}></article>
      {showHint && showScrollHint && (
        <div className="ea-article__scroll-hint">
          <span>{t("przewin_aby_zobaczyc_wiecej_opisu")}</span>
        </div>
      )}
    </div>
  );
};

export default EAArticle;
